import { usePage } from "@inertiajs/vue3";
import iziToast from "izitoast";
import Swal from "sweetalert2";
import { piauiBoundaries } from "./boundaries";
import axios from "axios";
export const deleteAlert = async (options) =>
    await Swal.fire({
        ...{
            title: "Deseja realmente excluir este registro?",
            text: "Você não poderá reverter isso!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "SIM",
            cancelButtonText: "CANCELAR",
            reverseButtons: true,
        },
        ...options,
    }).then((result) => {
        return result.value;
    });

export const toastMessage = ({ success, message }) => {
    if (success) {
        return iziToast.show({
            title: `Sucesso:`,
            message: `${message}`,
            position: "topCenter",
            animateInside: false,
            transitionIn: "fadeInDown",
            transitionInMobile: "fadeInDown",
            transitionOutMobile: "fadeOutUp",
            color: "green",
            timeout: 3000,
        });
    }

    return iziToast.show({
        title: `Erro:`,
        message: `${message}`,
        position: "topCenter",
        animateInside: false,
        transitionIn: "fadeInDown",
        transitionInMobile: "fadeInDown",
        transitionOutMobile: "fadeOutUp",
        color: "red",
        timeout: 8000,
    });
};

export const firstName = (name: String, capitalize: Boolean = true) => {
    if (typeof name !== "string" || name === "") {
        return "";
    }

    let primeiroNome = name.trim().split(" ")[0] ?? "";
    if(capitalize){
        return capitalizeFirstLetter(primeiroNome);
    }else {
        return primeiroNome;
    }
};

export const trimString = (string: string, length: number = 12) => {
    if (!string){
        return '';
    }

    if(string.length > length){
        return string.slice(0, length) + '...';
    }else{
        return string
    }
}

export const lastName = (name: String) => {
    if (typeof name !== "string" || name === "") {
        return "";
    }

    let nome = name.trim().split(" ");
    let ultimoNome = nome.length > 1 ? nome.slice(-1)[0] : "";
    return capitalizeFirstLetter(ultimoNome);
};

export const parseName = (name) => {
    return firstName(name) + " " + lastName(name);
};

function capitalizeFirstLetter(string: String) {
    if (string == "") return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

interface selectPayload {
    model: string;
    key: string;
    label: string;
    termKey?: string;
    term?: string;
    conditions?: string[];
    orderingKey?: string;
    ordering?: string;
    limit?: number;
}

export const selectOptions = async (payload: selectPayload) => {
    const params = {
        model: payload.model ?? null,
        key: payload.key ?? null,
        label: payload.label ?? null,
        termKey: payload.termKey ?? null,
        term: payload.term ?? null,
        conditions: payload.conditions ?? null,
        orderingKey: payload.orderingKey ?? null,
        ordering: payload.ordering ?? "ASC",
        limit: payload.limit ?? null,
    };
    return await axios
        .post(route("select.list.load"), {
            ...params,
        })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            return err.response.data;
        });
};

export const transformTime = (val, hideHours = false) => {
    const totalMinutes = Math.floor(val / 60);

    let seconds = val % 60;
    let hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;

    hours = String(hours).length < 2 ? "0" + hours : hours;
    minutes = String(minutes).length < 2 ? "0" + minutes : minutes;
    seconds = String(seconds).length < 2 ? "0" + seconds : seconds;

    return hideHours
        ? `${minutes}:${seconds}`
        : `${hours}:${minutes}:${seconds}`;
};

export const selectRoutes = () => {
    const ziggyRoutes = usePage().props?.ziggy.routes;
    const routeOptions = Object.keys(ziggyRoutes)
        .filter((key) => key.includes("index"))
        .map((key) => ({
            label: key,
            value: key,
        }));
    return routeOptions;
};

export const atualestoque = (val: String) =>{
    switch(val){
        case '-1':
            return 'SAÍDA';
            break;
        case '0':
            return '-';
            break;
        case '1':
            return 'ENTRADA';
            break;
        default:
            break;
    }
}

export const copyToClipboard = function (txt) {
    // Throws an error in dev because it's not https and secure. In production works fine.
    const cb = navigator.clipboard
    cb.writeText(txt).then(() =>
        toastMessage({success: true, message:`Texto ${txt} copiado!`})
    )
}

export const sobrenome = function (nome: string){
    let partes = nome.trim().split(' ');

    if(partes.length > 1){
        return `${partes[0]} ${partes.pop()}`
    }
    return partes[0]
}

export const renderStatus = function (status: string){
    switch(status){
        case 'P':
            return 'PENDENTE';
            break;
        case 'C':
            return 'CANCELADO';
            break;
        case 'E':
            return 'ENCERRADO';
            break;
        default:
            return 'INDEFINIDO';
            break;
    }
}

export const renderAndamentoStatus = function (status: string){
    switch(status){
        case 'P':
            return 'PENDENTE';
            break;
        case 'R':
            return 'REVISAR';
            break;
        case 'C':
            return 'CONCLUÍDO';
            break;
    }
}

export const renderTipoAndamento = function (andamento: string){
    switch (andamento) {
        case 'E':
            return 'ESCOLHER'
            break;
        case 'N':
            return 'ATENDIMENTO TÉCNICO'
            break;
        case 'S':
            return 'OBSERVAÇÃO'
            break;
        case 'C':
            return 'CANCELAMENTO'
            break;
        default:
            break;
    }
}

export const renderAndamentoTipoProb = function (tipoprob: string){
    switch (tipoprob){
        case 'M':
            return 'FALHA MECÂNICA'
            break;
        case 'E':
            return 'FALHA ELÉTRICA/ELETRÔNICA'
            break;
        case 'L':
            return 'FALHA LÓGICA (CONEXÃO/REDE)'
            break;
        case 'O':
            return 'FALHA OPERACIONAL'
            break;
        case 'S':
            return 'FALHA DE SUPRIMENTOS'
            break;
        case 'C':
            return 'CONFIGURAÇÃO'
            break;
    }
}


export function objectKeysOf(keys: Array<string>, form: object) : object {
    return keys?.reduce((carry, key) => {
        carry[key] = form[key]
        return carry
    }, {})
}

export function objectExceptKeysOf(keys: Array<string>, form: object) : object {
    return Object.keys(form).reduce((carry, key) => {
        if (keys.includes(key)){
            return carry;
        }
        carry[key] = form[key]
        return carry
    }, {})
}

type Coordenada = {
    lat: number,
    lng: number
}

export function validaCoordenada (p: Coordenada){


    var isInside = false;
    var minX = piauiBoundaries[0].lat,
        maxX = piauiBoundaries[0].lat;
    var minY = piauiBoundaries[0].lng,
        maxY = piauiBoundaries[0].lng;
    for (var n = 1; n < piauiBoundaries.length; n++) {
        var q = piauiBoundaries[n];
        minX = Math.min(q.lat, minX);
        maxX = Math.max(q.lat, maxX);
        minY = Math.min(q.lng, minY);
        maxY = Math.max(q.lng, maxY);
    }

    if (p.lat < minX || p.lat > maxX || p.lng < minY || p.lng > maxY) {
        return false;
    }

    var i = 0,
        j = piauiBoundaries.length - 1;
    for (j; i < piauiBoundaries.length; j = i++) {
        if (
            piauiBoundaries[i].lng > p.lng != piauiBoundaries[j].lng > p.lng &&
            p.lat <
                ((piauiBoundaries[j].lat - piauiBoundaries[i].lat) * (p.lng - piauiBoundaries[i].lng)) /
                    (piauiBoundaries[j].lng - piauiBoundaries[i].lng) +
                    piauiBoundaries[i].lat
        ) {
            isInside = !isInside;
        }
    }
    return isInside;

}


export const fetchProtocoloResource = async (osxwebId: number) => {
    return await axios
        .post(route('osxwebs.protocoloResource', { id: osxwebId }))
        .then((response) => {
            return response.data.protocolo
        })
        .catch((err) => {
            iziToast.error({title: 'Erro', message:err.response.data.message})
            return null
        })
    }


export function pushUnique(oldList, newList){
    var exists = false;
    for (const item of newList){
        exists = false;
        for (const set of oldList){
            if (item.id == set.id){
                exists = true;
                break;
            }
        }

        if (!exists){
            oldList.push(item);
        }
    }

    return oldList;
}

export function find(list, cb){
    let result = null;
    for (let i=0; i < list.length; i++){
        if (cb(list[i])){
            result = {
                item: list[i],
                index: i,
            };
            break;
        }
    }

    return result;
}

export function normalizeLatLng(lat: string, lng: string){

    let nLat: number|string[]  = typeof lat === 'string' && lat.includes('-') ? lat.split('-') : Number(lat)
    let nLng: number|string[] = typeof lng === 'string' && lng.includes('-') ? lng.split('-') : Number(lng)

    if(Array.isArray(nLat)){
        nLat = -Number(nLat.pop())
    }
    if(Array.isArray(nLng)){
        nLng = -Number(nLng.pop())
    }

    return {lat: nLat, lng: nLng}
}
